import React from "react"
import {getPageData} from "../pageData"
import {serverSideTranslations} from "next-i18next/serverSideTranslations"
import nextI18nextConfig from "../next-i18next.config"
import {useTranslation} from "next-i18next"
import MbpHead from "../components/head/MbpHead"
import NavBar from "../components/navigation/NavBar"
import Footer from "../components/footer/Footer"
import fetchReviews from "../fetch/FetchReviews"
import ConsultationContent from "../components/consultationPage/ConsultationContent"

type Props = {
    reviews: any[]
}
function Suggestion({reviews}:Props) {
	const {t} = useTranslation()
	const title = t("Consultation | MyBikePlan")
	const description = t("Consultation")
	return (
		<>
			<MbpHead>
				<title>
					{title}
				</title>
				<meta name="description"
					content={description}/>
				<meta property="og:title"
					content={title}/>
				<meta property="og:description"
					content={description}/>
			</MbpHead>

			<NavBar absolute={true} />

			<ConsultationContent reviews={reviews} />
			<Footer/>
		</>
	)
}

export default Suggestion

export async function getStaticProps({locale}) {
	const data = await getPageData(locale)
	const brandWidgets = data?.strapiContent?.data?.premium_brand_widgets

	const reviews = fetchReviews()
	const allPremiumBrandsGoogleReviews = brandWidgets.reduce((acc, item) => {
		if (item?.attributes?.googleReviews && Array.isArray(item?.attributes?.googleReviews)) {
			return acc.concat(item?.attributes?.googleReviews)
		}

		return acc
	}, []) || []
	reviews.reviews = allPremiumBrandsGoogleReviews.concat(reviews?.reviews)
	return {
		props: {
			reviews,
			...data,
			...(await serverSideTranslations(locale, ["common", "URL", "search", "filters"], nextI18nextConfig))
		}
	}
}
